// Beschreibungen ausschließlich für Navigationskarten; keine Feld- oder Aktionstexte.
export const settingsNavigationDe = {
  "SettingsCards.settings.legal-text-settings": "Datenschutz, AGB und Impressum zuweisen",
  "SettingsCards.settings.person-defaults": "Anrede, Geburtstagsaufgaben und Startseite",
  "SettingsCards.settings.checkin-view": "Darstellung, Checkout- und Historiezeiten",
  "SettingsCards.settings.templates": "Pakete und Varianten für Vertragsabschlüsse",
  "SettingsCards.settings.payment-plans": "Vorlagen für Ratenzahlungen",
  "SettingsCards.settings.articles": "Artikel und Verkaufspreise",
  "SettingsCards.settings.contract-option-groups": "Wahl- und Zusatzbausteine für Vertragspakete",
  "SettingsCards.settings.sales-promotions": "Befristete Angebote für Vertragsabschlüsse",
  "SettingsCards.settings.member-promotion-templates": "Regeln für Empfehlungen und Prämien",
  "SettingsCards.settings.payment-methods": "Zahlungsarten für Mitgliederzahlungen",
  "SettingsCards.settings.cash-registers": "Standardkassen für Barzahlungen",
  "SettingsCards.settings.letter-email-templates": "Vorlagen für Briefe und E-Mails",
  "SettingsCards.settings.whatsapp-templates": "Zuordnung freigegebener Meta-Vorlagen",
  "SettingsCards.settings.sms-templates": "Textvorlagen für Nachrichten und Abläufe",
  "SettingsCards.settings.document-appearance": "Briefkopf, Logo und Fußzeile",
  "SettingsCards.settings.fonts": "Eigene Schriftarten für Briefe und E-Mails",
  "SettingsCards.settings.resource-unavailabilities": "Abwesenheiten und ihre Gründe",
  "SettingsCards.settings.booking-widgets": "Onlinebuchung, Design und Einbettung",
  "SettingsCards.settings.appointment-notifications": "Bestätigungen und Erinnerungen per E-Mail/SMS",
  "SettingsCards.settings.staff-activity-types": "Tätigkeiten und Arbeitszeitanrechnung",
  "SettingsCards.settings.staff-absence-types": "Urlaub, Krankheit und weitere Abwesenheiten",
  "SettingsCards.settings.staff-profiles": "Sollstunden und Beschäftigungszeiträume",
  "SettingsCards.settings.staff-hr": "Zeiterfassung, Personal und Überstunden",
  "SettingsCards.settings.staff-week-plan-links": "Öffentliche Zugänge zum Wochenplan",
  "SettingsCards.settings.studio-app": "Design, Funktionen, Studios und Rechtstexte",
  "SettingsCards.settings.default-theme": "Team-Standard ohne persönliche Theme-Auswahl",
  "SettingsCards.settings.integrations": "Externe Anbindungen und Zugangsdaten",
  "SettingsCards.settings.tenant-deletion": "Datenlöschung nach Ende des Tarifs beantragen",
  "SettingsCards.admin.units": "Datum, Uhrzeit, Zeitzone und Währung",
  "SettingsCards.admin.billing": "Tarifkatalog und Zahlungsanbieter",
  "SettingsCards.admin.invoices": "Rechnungen, Absender und Rechnungsdesign",
  "SettingsCards.admin.bank-data": "Bankverzeichnis und automatische Aktualisierung",
  "SettingsCards.admin.themes": "Verfügbare Themes und App-Standard",
  "SettingsCards.admin.studio-app": "App-Design und Einstellungen je Mandant",
  "SettingsCards.admin.gateway": "Verbindung zum Gateway",
  "SettingsCards.admin.holidays": "Feiertage nach Land und Region importieren",
  "SettingsCards.admin.fonts": "Schriftarten für alle Mandanten",
  "SettingsCards.admin.email": "Versandkonten und Systemvorlagen",
  "SettingsCards.admin.integrations": "Anbindungen des Admin-Mandanten",
  "SettingsCards.admin.ai": "Anbieter, Modelle, Agentenzuordnung und Kosten",
  "SettingsCards.admin.versioning": "Versionsbeschreibungen und Änderungsprotokoll",
} as const;

export const settingsNavigationEn = {
  "SettingsCards.settings.legal-text-settings": "Assign privacy policy, terms and imprint",
  "SettingsCards.settings.person-defaults": "Salutation, birthday tasks and start page",
  "SettingsCards.settings.checkin-view": "Display, checkout and history windows",
  "SettingsCards.settings.templates": "Packages and variants for contract signing",
  "SettingsCards.settings.payment-plans": "Installment payment templates",
  "SettingsCards.settings.articles": "Articles and sales prices",
  "SettingsCards.settings.contract-option-groups": "Optional and additional package components",
  "SettingsCards.settings.sales-promotions": "Limited-time offers for contract signing",
  "SettingsCards.settings.member-promotion-templates": "Referral and reward rules",
  "SettingsCards.settings.payment-methods": "Methods for member payments",
  "SettingsCards.settings.cash-registers": "Default registers for cash payments",
  "SettingsCards.settings.letter-email-templates": "Letter and email templates",
  "SettingsCards.settings.whatsapp-templates": "Map approved Meta templates",
  "SettingsCards.settings.sms-templates": "Message and workflow text templates",
  "SettingsCards.settings.document-appearance": "Letterhead, logo and footer",
  "SettingsCards.settings.fonts": "Custom fonts for letters and emails",
  "SettingsCards.settings.resource-unavailabilities": "Unavailabilities and their reasons",
  "SettingsCards.settings.booking-widgets": "Online booking, design and embedding",
  "SettingsCards.settings.appointment-notifications": "Confirmations and reminders by email/SMS",
  "SettingsCards.settings.staff-activity-types": "Activities and working-time credit",
  "SettingsCards.settings.staff-absence-types": "Vacation, sickness and other absences",
  "SettingsCards.settings.staff-profiles": "Target hours and employment periods",
  "SettingsCards.settings.staff-hr": "Time tracking, HR and overtime",
  "SettingsCards.settings.staff-week-plan-links": "Public access to the weekly schedule",
  "SettingsCards.settings.studio-app": "Design, features, studios and legal texts",
  "SettingsCards.settings.default-theme": "Team default without a personal theme choice",
  "SettingsCards.settings.integrations": "External integrations and credentials",
  "SettingsCards.settings.tenant-deletion": "Request data deletion after the plan ends",
  "SettingsCards.admin.units": "Date, time, time zone and currency",
  "SettingsCards.admin.billing": "Plan catalogue and payment providers",
  "SettingsCards.admin.invoices": "Invoices, sender and invoice design",
  "SettingsCards.admin.bank-data": "Bank directory and automatic updates",
  "SettingsCards.admin.themes": "Available themes and app default",
  "SettingsCards.admin.studio-app": "App design and settings per tenant",
  "SettingsCards.admin.gateway": "Gateway connection",
  "SettingsCards.admin.holidays": "Import holidays by country and region",
  "SettingsCards.admin.fonts": "Fonts for all tenants",
  "SettingsCards.admin.email": "Sending accounts and system templates",
  "SettingsCards.admin.integrations": "Admin tenant integrations",
  "SettingsCards.admin.ai": "Providers, models, agent assignments and costs",
  "SettingsCards.admin.versioning": "Version descriptions and changelog",
} as const;

